import VehicleDetail from "./VehicleDetail";
import { vehiclesData } from "../data/vehiclesData";

function MercedesClasseV() {
  return <VehicleDetail vehicle={vehiclesData.mercedesV} />;
}

export default MercedesClasseV;